'use client';

// import { useViewColorScheme } from '@/lib/store/hooks';
import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import { PAGE_STANDARD_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useColorScheme } from '@/lib/parsers/common';
import { withFragment } from '@liquorice/gql-utils';
import Breadcrumbs from '../Breadcrumbs';
import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';
import PageTitle from './PageTitle';

const PageHeaderStandard = withFragment(PAGE_STANDARD_CARD_FRAGMENT, (data) => {
  const base = getFragmentData(ENTRY_BASE_FRAGMENT, data);
  const { colorScheme, oppositeScheme } = useColorScheme(data?.colorScheme);

  if (!data) return null;

  return (
    <PageHeaderRoot
      variant="standard"
      colorSet={colorScheme}
      paper
      GridColProps={{ cx: { mY: '5xl' } }}>
      <Breadcrumbs data={base} CtaButtonProps={{ color: oppositeScheme }} cx={{ mB: 'xs' }} />
      <PageTitle uppercase cx={{ mB: 'xs' }}>
        {data.entryTitle}
      </PageTitle>
      <PageSummary useGridCol={false}>{data.entrySummary}</PageSummary>
    </PageHeaderRoot>
  );
});

export default PageHeaderStandard;
